// extracted by mini-css-extract-plugin
module.exports = {"logo":"ao0_cz","black":"ao0_ao1"};